import { useQuery } from "@tanstack/react-query";

import banners, { baseURLBannersAPI } from "../../services/banners";
import { queryKeys } from "../api/queryKeys";
import { BANNERS_MARKETING_STALE_MS, useBannersToken } from "./useBannersToken";

interface Banner {
  id: number;
  image: string;
  url: string;
  urlType: string;
}

export const useBanners = () => {
  const { data: tokenPayload, isSuccess: tokenReady } = useBannersToken();

  return useQuery<Banner[]>({
    queryKey: queryKeys.banners,
    enabled: tokenReady && !!tokenPayload?.token && !!baseURLBannersAPI,
    queryFn: async () => {
      const { data } = await banners.get<Banner[]>(
        "/banner/getCurrentBanners",
        {
          headers: {
            Authorization: `Bearer ${tokenPayload!.token}`,
          },
        }
      );

      return data;
    },
    staleTime: BANNERS_MARKETING_STALE_MS,
  });
};
